<div class="speaker-talent-form-container">
  <form nz-form [formGroup]="form" [nzLayout]="'vertical'">

    <div class="form-section">
      <!-- <div class="section-header">
        <h3 class="section-title">Speaker & Talent Requirements</h3>
      </div> -->

      <nz-form-item>
        <nz-form-label nzRequired>Speaker Details</nz-form-label>
        <nz-form-control>
          <nz-select nzMode="multiple" nzShowSearch nzAllowClear formControlName="speaker_on_stage_talent"
            nzPlaceHolder="Select speaker details">
            <nz-option *ngFor="let v of speakerTalentOptionsResponseModel.value.results" [nzValue]="v.id"
              [nzLabel]="v.name">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button nzType="primary" (click)="onSave()" [disabled]="form.invalid">
            Submit
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>

  </form>
</div>